var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 99c-3.8 0-7-3.2-7-7V8c0-3.8 3.2-7 7-7h144c3.8 0 7 3.2 7 7v84c0 3.8-3.2 7-7 7H8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 2c3.3 0 6 2.7 6 6v84c0 3.3-2.7 6-6 6H8c-3.3 0-6-2.7-6-6V8c0-3.3 2.7-6 6-6h144zm0-2H8C3.6 0 0 3.6 0 8v84c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 33.507,
    y1: 59.005,
    x2: 133.468,
    y2: 39.797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22275d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24479b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.4 31.5l-7.9 37h-9.6l7.9-37h9.6zm40.3 23.9l5-13.9 2.9 13.9h-7.9zm10.7 13.2h8.9l-7.7-37h-8.2c-1.8 0-3.4 1.1-4.1 2.7l-14.4 34.3H115l2-5.5h12.3l1.1 5.5zm-25-12.1c0-9.8-13.5-10.3-13.4-14.7 0-1.3 1.3-2.7 4.1-3.1 1.4-.2 5.2-.3 9.4 1.7l1.7-7.9c-2.3-.8-5.3-1.6-9-1.6-9.5 0-16.1 5-16.2 12.2-.1 5.3 4.8 8.3 8.4 10.1 3.7 1.8 5 3 5 4.6 0 2.5-3 3.6-5.7 3.6-4.8.1-7.6-1.3-9.8-2.3l-1.7 8.1c2.2 1 6.4 1.9 10.7 2 9.9-.1 16.5-5 16.5-12.7m-39.7-25l-15.5 37H40.1L32.4 39c-.5-1.8-.9-2.5-2.3-3.3-2.3-1.2-6.1-2.4-9.5-3.1l.2-1.1h16.3c2.1 0 3.9 1.4 4.4 3.8l4 21.4 10-25.2h10.2z",
    fill: "url(#a)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.bd37a379cc4bcbe73f42743fcb42b0d8.svg";
export { ForwardRef as ReactComponent };